/*
 * BT Four-Pack — aggiunta al carrello dai suggerimenti "Complete your Four-Pack".
 * Un solo listener delegato: i bottoni vengono ri-renderizzati da Minimog a ogni aggiornamento
 * del carrello (Section Rendering), quindi non si attaccano handler ai singoli elementi.
 * Dopo l'add emette lo stesso evento cartUpdate che usa Minimog, così drawer, pagina e contatore
 * si aggiornano con la loro logica.
 */
(function () {
  if (window.__btFourpackReady) return;
  window.__btFourpackReady = true;

  function sectionName() {
    var el = document.querySelector('m-cart-items');
    return (el && el.dataset.sectionName) || 'cart-template';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bt-fp-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var variantId = parseInt(btn.dataset.btFpAdd, 10);
    if (!variantId) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: [sectionName(), 'cart-count'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) throw new Error(res.description || res.message || 'Cart error');
        // /cart/add.js restituisce le righe aggiunte + sections: per il resto rileggo il carrello
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = res.sections;
            if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
              window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: cart });
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }
          });
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        if (window.MinimogTheme && window.MinimogTheme.Notification) {
          window.MinimogTheme.Notification.show({ target: btn, type: 'warning', message: err.message });
        }
      });
  });
})();

/*
 * Aggiunta di più varianti in un colpo (pagina Four-Pack: "Add all 4"): data-bt-fp-add-many='[id,id,id,id]'.
 */
(function () {
  if (window.__btFourpackManyReady) return;
  window.__btFourpackManyReady = true;
  function sectionName() {
    var el = document.querySelector('m-cart-items');
    return (el && el.dataset.sectionName) || 'cart-drawer';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bt-fp-add-many]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var ids = [];
    try { ids = JSON.parse(btn.getAttribute('data-bt-fp-add-many') || '[]'); } catch (err) {}
    if (!ids.length) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }), sections: [sectionName(), 'cart-count'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) throw new Error(res.description || res.message || 'Cart error');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = res.sections;
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: cart });
          }
          var drawer = document.querySelector('m-cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          btn.textContent = 'Added';
          setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2500);
        });
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        if (window.MinimogTheme && window.MinimogTheme.Notification) {
          window.MinimogTheme.Notification.show({ target: btn, type: 'warning', message: err.message });
        }
      });
  });
})();

/*
 * Chip "Log in": apre il login in un popup e resta sulla pagina. Ogni 2 secondi chiede al tema se il cliente
 * è entrato (sezione bt-customer-state); appena sì, chiude il popup e ricarica la pagina, che ora è personalizzata.
 * Popup bloccato → il link funziona come link normale (con return_to).
 */
(function () {
  if (window.__btFpLoginReady) return;
  window.__btFpLoginReady = true;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-fp-login]');
    if (!a) return;
    var w = 520, h = 720;
    var left = Math.max(0, (window.screen.width - w) / 2), top = Math.max(0, (window.screen.height - h) / 2);
    var win = window.open(a.href, 'bt_login', 'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',menubar=no,toolbar=no');
    if (!win) return; // popup bloccato: navigazione normale
    e.preventDefault();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (win.closed || tries > 300) { clearInterval(timer); if (!win.closed) return; }
      fetch(root + '?section_id=bt-customer-state', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (html.indexOf('"logged":true') < 0) return;
          clearInterval(timer);
          try { win.close(); } catch (err) {}
          window.location.reload();
        })
        .catch(function () {});
    }, 2000);
  });
})();

/*
 * Pagina Four-Pack: scelta del device (URL ?device=, memoria del browser, device dei pack nel carrello, primo)
 * e filtro per famiglia. Tutto è già nell'HTML: qui si mostra e si nasconde.
 */
(function () {
  var page = document.querySelector('[data-fp-page]');
  if (!page) return;
  var chips = Array.prototype.slice.call(page.querySelectorAll('[data-fp-page-device]'));
  var panels = Array.prototype.slice.call(page.querySelectorAll('[data-fp-page-panel]'));
  if (!chips.length) return;
  var devices = chips.map(function (c) { return c.dataset.fpPageDevice; });

  function show(device) {
    if (devices.indexOf(device) < 0) device = devices[0];
    chips.forEach(function (c) { c.setAttribute('aria-selected', c.dataset.fpPageDevice === device ? 'true' : 'false'); });
    panels.forEach(function (p) { p.hidden = p.dataset.fpPagePanel !== device; });
    try { localStorage.setItem('bt_fp_device', device); } catch (e) {}
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('device', device);
      history.replaceState(null, '', u.toString());
    } catch (e) {}
  }

  chips.forEach(function (c) { c.addEventListener('click', function () { show(c.dataset.fpPageDevice); }); });
  page.addEventListener('click', function (e) {
    var f = e.target.closest('[data-fp-page-family]');
    if (!f) return;
    var panel = f.closest('[data-fp-page-panel]');
    var fam = f.dataset.fpPageFamily;
    panel.querySelectorAll('[data-fp-page-family]').forEach(function (x) { x.classList.toggle('is-on', x === f); });
    panel.querySelectorAll('[data-fp-family]').forEach(function (s) { s.hidden = fam !== 'all' && s.dataset.fpFamily !== fam; });
  });

  var fromUrl = null;
  try { fromUrl = new URL(window.location.href).searchParams.get('device'); } catch (e) {}
  var stored = null;
  try { stored = localStorage.getItem('bt_fp_device'); } catch (e) {}
  if (fromUrl && devices.indexOf(fromUrl) >= 0) { show(fromUrl); return; }
  if (stored && devices.indexOf(stored) >= 0) { show(stored); return; }
  show(devices[0]);
  // Il device dei pack già nel carrello vince sul primo della lista (chi arriva dal carrello ha già scelto).
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
    var counts = {};
    (cart.items || []).forEach(function (it) {
      (it.options_with_values || []).forEach(function (o) { if (o.name === 'Device') counts[o.value] = (counts[o.value] || 0) + it.quantity; });
    });
    var best = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
    if (best && devices.indexOf(best) >= 0 && !stored) show(best);
  }).catch(function () {});
})();

/*
 * PDP: il blocco "Complete your Four-Pack" segue il device selezionato (evento variant:changed di Minimog,
 * mappe device→variante nei data-attribute) e "Add all 4" aggiunge i 4 pack in una chiamata sola.
 */
(function () {
  var block = document.querySelector('[data-fp-block]');
  if (!block || block.__btReady) return;
  block.__btReady = true;

  function money(cents) {
    var fmt = (window.MinimogSettings && window.MinimogSettings.money_format) || (window.Shopify && window.Shopify.money_format) || '€{{amount}}';
    var v = (cents / 100).toFixed(2);
    if (fmt.indexOf('amount_with_comma_separator') > -1) v = v.replace('.', ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }

  function apply(device) {
    var total = 0, count = 0, min = null;
    block.querySelectorAll('[data-fp-card], [data-fp-self]').forEach(function (card) {
      var map = {};
      try { map = JSON.parse(card.getAttribute('data-fp-variants') || '{}'); } catch (e) {}
      var v = map['*'] || map[device];
      var btn = card.querySelector('[data-bt-fp-add]');
      if (!v) {
        card.classList.add('bt-fpp__card--na');
        card.dataset.fpVariant = '';
        if (btn) btn.setAttribute('data-bt-fp-add', '');
        return;
      }
      card.classList.remove('bt-fpp__card--na');
      card.dataset.fpVariant = v.id;
      var p = card.querySelector('[data-fp-price]');
      if (p) p.textContent = money(v.price);
      if (btn) btn.setAttribute('data-bt-fp-add', v.id);
      total += v.price;
      count++;
      if (min === null || v.price < min) min = v.price;
    });
    var all = block.querySelector('[data-bt-fp-add-all]');
    var save = block.querySelector('[data-fp-all-save]');
    if (all) {
      var lbl = all.querySelector('[data-fp-all-label]');
      if (count === 4) {
        all.disabled = false;
        lbl.textContent = 'Add all 4 · ' + money(total - min);
        if (save) save.textContent = 'You save ' + money(min);
      } else {
        all.disabled = true;
        lbl.textContent = 'Add all 4';
        if (save) save.textContent = '';
      }
    }
    var dl = block.querySelector('[data-fp-device-label]');
    if (dl && device) dl.textContent = device;
  }

  apply(block.dataset.fpDevice || '');
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.option1) {
      block.dataset.fpDevice = v.option1;
      apply(v.option1);
    }
  });

  var addAll = block.querySelector('[data-bt-fp-add-all]');
  if (!addAll) return;
  addAll.addEventListener('click', function () {
    var items = [];
    block.querySelectorAll('[data-fp-self], [data-fp-card]').forEach(function (c) {
      var id = parseInt(c.dataset.fpVariant, 10);
      if (id && !c.classList.contains('bt-fpp__card--na')) items.push({ id: id, quantity: 1 });
    });
    if (items.length !== 4) return;
    var lbl = addAll.querySelector('[data-fp-all-label]');
    var label = lbl.textContent;
    addAll.disabled = true;
    lbl.textContent = 'Adding…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-count'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) throw new Error(res.description || res.message || 'Cart error');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = res.sections;
            if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
              window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: cart });
            }
            var drawer = document.querySelector('m-cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            lbl.textContent = 'Added';
            setTimeout(function () { addAll.disabled = false; lbl.textContent = label; }, 2500);
          });
      })
      .catch(function (err) {
        addAll.disabled = false;
        lbl.textContent = label;
        if (window.MinimogTheme && window.MinimogTheme.Notification) {
          window.MinimogTheme.Notification.show({ target: addAll, type: 'warning', message: err.message });
        }
      });
  });
})();

/*
 * Codice dal link /discount/<codice> (email Klaviyo, es. welcome): Shopify lo mette nel cookie discount_code e lo
 * applica solo al checkout. Qui lo si applica al carrello (/cart/update.js), così si vede già nel drawer.
 * Una volta sola per codice (localStorage bt_dc_done): se il cliente lo toglie non ricompare. Se nel carrello c'è
 * già un altro codice non si tocca niente. Carrello vuoto → si riprova al prossimo aggiornamento del carrello.
 */
(function () {
  if (window.__btDiscountCookieReady) return;
  window.__btDiscountCookieReady = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]).trim(); } catch (e) { return m[1].trim(); }
  }
  function done(code) {
    try { return localStorage.getItem('bt_dc_done') === code; } catch (e) { return true; }
  }
  function markDone(code) {
    try { localStorage.setItem('bt_dc_done', code); } catch (e) {}
  }
  function sectionName() {
    var el = document.querySelector('m-cart-items');
    return (el && el.dataset.sectionName) || 'cart-drawer';
  }

  function run() {
    var code = cookieCode();
    if (!code || busy || done(code)) return;
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return String(d.code || '').toUpperCase(); });
        if (codes.indexOf(code.toUpperCase()) > -1) { markDone(code); return; }
        if (codes.length) { markDone(code); return; } // il cliente ha già un altro codice: si rispetta
        if (!cart.item_count) return; // carrello vuoto: si riprova quando aggiunge qualcosa
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code, sections: [sectionName(), 'cart-count'] })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status && res.status >= 400) return;
            markDone(code);
            if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
              window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: res });
            }
          });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var subscribed = false;
  function subscribe() {
    if (subscribed) return;
    if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function' && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      subscribed = true;
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function () { setTimeout(run, 300); });
    }
  }
  run();
  subscribe();
  window.addEventListener('load', function () { subscribe(); run(); });
})();
